'use client';

declare global {
  interface Window {
    appier?: (...args: any[]) => void;
  }
}

export const sendAppierEvent = (event: string, data: Record<string, any>): void => {
  if (window.appier) {
    window.appier('event', event, data);
  } else {
    console.warn('Appier 未載入');
  }
};

export const sendAppierIdentify = (data: Record<string, any>): void => {
  if (window.appier) {
    window.appier('identify', data);
  } else {
    console.warn('Appier 未載入');
  }
};
